<script lang="ts">
	import { Switch } from '$lib/components/ui/switch';
	import { Label } from '$lib/components/ui/label';

	let { class: _class = '', annually = $bindable(true) } = $props();
</script>

<div class="flex items-center justify-center space-x-2 pb-2 {_class}">
	<Label for="billingPeriod" class={annually ? 'font-medium' : 'font-bold'}>Monthly</Label>
	<Switch id="billingPeriod" bind:checked={annually} />
	<Label for="billingPeriod" class={annually ? 'font-bold' : 'font-medium'}>Annually</Label>
</div>
